import React from 'react';
import { Card, Form, Input, Button, Typography, Space, Switch, message } from 'antd';
import { UserOutlined, MailOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';

const { Title, Text } = Typography;

const Settings: React.FC = () => {
  const { user } = useAuth();
  const [form] = Form.useForm();

  const handleSaveProfile = (values: any) => {
    message.success('Profil bilgileri güncellendi');
  };

  const handleChangePassword = (values: any) => {
    message.success('Şifre değiştirildi');
  };

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <Title level={2}>Ayarlar</Title>
        <Text type="secondary">Hesap ve bildirim ayarlarınızı yönetin</Text>
      </div>

      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Card title="Profil Bilgileri">
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSaveProfile}
            initialValues={{
              name: user?.name,
              email: user?.email,
            }}
          >
            <Form.Item
              name="name"
              label="Ad Soyad"
              rules={[{ required: true, message: 'Ad soyad zorunludur' }]}
            >
              <Input prefix={<UserOutlined />} placeholder="Ad Soyad" />
            </Form.Item>

            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: 'Email zorunludur' },
                { type: 'email', message: 'Geçerli bir email girin' },
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="Email" disabled />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit">
                Kaydet
              </Button>
            </Form.Item>
          </Form>
        </Card>

        <Card title="Şifre Değiştir">
          <Form layout="vertical" onFinish={handleChangePassword}>
            <Form.Item
              name="currentPassword"
              label="Mevcut Şifre"
              rules={[{ required: true, message: 'Mevcut şifre zorunludur' }]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="Mevcut Şifre" />
            </Form.Item>

            <Form.Item
              name="newPassword"
              label="Yeni Şifre"
              rules={[
                { required: true, message: 'Yeni şifre zorunludur' },
                { min: 8, message: 'Şifre en az 8 karakter olmalıdır' },
              ]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="Yeni Şifre" />
            </Form.Item>

            <Form.Item
              name="confirmPassword"
              label="Yeni Şifre (Tekrar)"
              dependencies={['newPassword']}
              rules={[
                { required: true, message: 'Şifre tekrarı zorunludur' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Şifreler eşleşmiyor'));
                  },
                }),
              ]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="Yeni Şifre (Tekrar)" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit">
                Şifreyi Değiştir
              </Button>
            </Form.Item>
          </Form>
        </Card>

        <Card title="Bildirim Tercihleri">
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <Text strong>Email Bildirimleri</Text>
                <br />
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Yeni ürün ve güncellemeler hakkında email alın
                </Text>
              </div>
              <Switch defaultChecked />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <Text strong>Haftalık Rapor</Text>
                <br />
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Her hafta performans raporunu email olarak alın
                </Text>
              </div>
              <Switch defaultChecked />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <Text strong>Sistem Bildirimleri</Text>
                <br />
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Önemli sistem güncellemeleri hakkında bilgilendirilme
                </Text>
              </div>
              <Switch defaultChecked />
            </div>
          </Space>
        </Card>
      </Space>
    </div>
  );
};

export default Settings;

